import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// quiz questions
export interface IQuestion {
  id: number;
  question: string;
  optionA: string;
  optionB: string;
  optionC: string;
  optionD: string;
  correctAnswer: string;
  image: string;
}

// random quiz
export interface IRandomQuestions {
  id: number;
  question: string;
  optionA: string;
  optionB: string;
  optionC: string;
  optionD: string;
  correctAnswer: string;
  questionNo: number;
  isCorrect: boolean;
  timeTaken: number;
}

interface IUSER {
  name: string;
  email: string;
  phoneNumber: string;
}

export interface IUsersData {
  id: number;
  link: string;
  status: boolean;
}

interface IRoot {
  user?: IUSER;
  totalQuestions: number;
  quizTimer: number;
  selectedOutFit: number | null;
  selectedBackground: number | null;
  usersData: IUsersData;
}

const initialState: IRoot = {
  user: {
    name: "",
    email: "",
    phoneNumber: "",
  },
  totalQuestions: 10,
  quizTimer: 10,
  selectedOutFit: null,
  selectedBackground: null,
  usersData: {
    id: 0,
    link: "",
    status: false,
  },
};

const slice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser(state, action) {
      state.user = action.payload;
    },
    selectedOutFit(state, action: PayloadAction<null | number>) {
      state.selectedOutFit = action.payload;
    },
    selectedBackground(state, action: PayloadAction<null | number>) {
      state.selectedBackground = action.payload;
    },
    usersData(state, action: PayloadAction<IUsersData>) {
      state.usersData = action.payload;
    },
    resetAll(state) {
      state.selectedOutFit = null;
      state.selectedBackground = null;
      state.usersData = initialState.usersData;
    },
  },
});

export const UserActions = slice.actions;

export const reducer = slice.reducer;

export default slice;
